import {ResumeFsm,CdaNavigation,CdasNavigation} from '@/store/modules/fsm/messages';
import router from '@/router/index';

export default ({tree,parent,api}) => {
  if(!tree)
  { //our state is 'active'.  _lib added it
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs,nextRouterHook, navigate } = api;
    let here = parent.active;

    here.init
      .to(here.cdas);
    here.cdas
      .to(here.cda)
      .when(messageIs(CdaNavigation))
      .effect(nextRouterHook);
    here.cda
      .to(here.cdas)
      .when(messageIs(CdasNavigation))
      .effect(nextRouterHook);
    here.cdas
      .to()
      .when(messageIs(ResumeFsm))
      .effect(navigate(CdasNavigation));
    here.cda
      .to()
      .when(messageIs(ResumeFsm))
      .effect(navigate(CdaNavigation,{index:({context})=>context.rootState.login.cda.cdaIndex}))
  }
};
